// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.590088L2.00015 0.585938L0.585938 2.00015L5.08579 6.5H2V21.5H20.0858L22.0002 23.4144L23.4101 22.0045L2 0.594389L2.0043 0.590088Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 17.766V6.5H16.5V2.5H7.5V3.26596L9.5 5.26596V4.5H14.5V6.5H10.734L22 17.766Z"}}]};

const WorkOffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'work-off-filled',
    ref,
    icon: element,
  },
));

WorkOffFilledIcon.displayName = 'WorkOffFilledIcon';

export default WorkOffFilledIcon;
